import { useRef, useEffect } from 'react'
import PropTypes from 'prop-types';
import NotificationBell from './NotificationBell'
import NotificationPopover from './NotificationPopover';


const NotificationPopup = ({
	isActive,
	pivotNotification,
	unseenNotifications,
	notificationArr,
	onlyUnRead,
	getAllNotifications,
	markReadNotificationItem,
	markReadAllNotifications,
	showUnreadNotifications,
	initNotifications,
	handleRedirect,
	setIsActive,
	handleIconClick,
	loading,
	handlePopup
}) => {

	const notification = useRef();

	useEffect(() => {
		const checkIfClickedOutside = (e) => {
			if (isActive && notification.current && !notification.current.contains(e.target)) {
				handleIconClick(false)
			}
		}
		document.addEventListener("click", checkIfClickedOutside)
		return () => {
			document.removeEventListener("click", checkIfClickedOutside)
		}
	}, [isActive])

	return (
		<div ref={notification}>
			<div className="" >
				<NotificationBell isActive={isActive} handleIconClick={handleIconClick} unseenNotifications={unseenNotifications ?? []} />

				<NotificationPopover
					isActive={isActive}
					pivotNotification={pivotNotification}
					notificationArr={notificationArr}
					onlyUnRead={onlyUnRead}
					getAllNotifications={getAllNotifications}
					markReadNotificationItem={markReadNotificationItem}
					markReadAllNotifications={markReadAllNotifications}
					showUnreadNotifications={showUnreadNotifications}
					initNotifications={initNotifications}
					handleRedirect={handleRedirect}
					setIsActive={setIsActive}
					loading={loading}
					handlePopup={handlePopup}
				/>
			</div>

		</div>
	)
}

export default NotificationPopup


NotificationPopup.propTypes = {
	isActive: PropTypes.bool.isRequired,
	pivotNotification: PropTypes.string,
	unseenNotifications: PropTypes.arrayOf(PropTypes.number).isRequired,
	notificationArr: PropTypes.arrayOf(PropTypes.object).isRequired,
	onlyUnRead: PropTypes.bool,
	getAllNotifications: PropTypes.func.isRequired,
	markReadNotificationItem: PropTypes.func.isRequired,
	markReadAllNotifications: PropTypes.func.isRequired,
	showUnreadNotifications: PropTypes.func.isRequired,
	initNotifications: PropTypes.func.isRequired,
	handleRedirect: PropTypes.func.isRequired,
	setIsActive: PropTypes.func.isRequired,
	handleIconClick: PropTypes.func.isRequired,
	loading: PropTypes.bool.isRequired,
	handlePopup: PropTypes.func.isRequired
};
